/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import {
    ON_HORIZONTAL_KEY_PRESS_FILTERED_GUIDE,
    ON_KEY_OK_FILTERED_GUIDE,
    ON_SET_HORIZONTAL_POSITION_FILTERED_GUIDE,
    ON_SET_VERTICAL_POSITION_FILTERED_GUIDE,
    ON_VERTICAL_KEY_PRESS_FILTERED_GUIDE,
} from './filteredguide.navigation.types';

export const onVerticalKeyPressFilteredGuideAction = (
    verticalPosition: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_VERTICAL_KEY_PRESS_FILTERED_GUIDE,
    payload: {
        verticalPosition,
    },
});

export const onHorizontalKeyPressFilteredGuideAction = (
    horizontalPosition: number,
): TivoPayloadAction<{ horizontalPosition: number }> => ({
    type: ON_HORIZONTAL_KEY_PRESS_FILTERED_GUIDE,
    payload: {
        horizontalPosition,
    },
});

export const onKeyOkFilteredGuideAction = (): TivoPayloadAction<{}> => ({
    type: ON_KEY_OK_FILTERED_GUIDE,
    payload: {},
});

export const onSetVerticalPositionFilteredGuideAction = (
    verticalPosition: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_SET_VERTICAL_POSITION_FILTERED_GUIDE,
    payload: {
        verticalPosition,
    },
});

export const onSetHorizontalPositionFilteredGuideAction = (
    horizontalPosition: number,
): TivoPayloadAction<{ horizontalPosition: number }> => ({
    type: ON_SET_HORIZONTAL_POSITION_FILTERED_GUIDE,
    payload: {
        horizontalPosition,
    },
});
